export const PRICING_PLANS = [
    {
        id: 1,
        limitId: 1,
        name: 'Free',
        price: 0,
        description: 'Explore the platform and test strategies',
        highlighted: false,
        icon: 'mdi:rocket-launch-outline',
        maxAutomations: 0,
        maxMonitors: 0,
        maxBacktests: 10,
        hasFutures: false,
        cta: 'Get started free',
        ctaTo: '/register',
    },
    {
        id: 2,
        limitId: 2,
        name: 'Basic',
        price: 10,
        description: 'For traders running a focused bot stack',
        highlighted: false,
        icon: 'mdi:leaf',
        maxAutomations: 10,
        maxMonitors: 10,
        maxBacktests: 50,
        hasFutures: true,
        cta: 'Choose Basic',
        ctaTo: '/subscription',
    },
    {
        id: 3,
        limitId: 3,
        name: 'Standard',
        price: 20,
        description: 'Best for active multi-strategy traders',
        highlighted: true,
        icon: 'mdi:star-four-points-outline',
        maxAutomations: 20,
        maxMonitors: 20,
        maxBacktests: 100,
        hasFutures: true,
        cta: 'Choose Standard',
        ctaTo: '/subscription',
    },
    {
        id: 4,
        limitId: 4,
        name: 'Premium',
        price: 50,
        description: 'Maximum capacity for power users',
        highlighted: false,
        icon: 'mdi:lightning-bolt-outline',
        maxAutomations: 50,
        maxMonitors: 50,
        maxBacktests: 200,
        hasFutures: true,
        cta: 'Choose Premium',
        ctaTo: '/subscription',
    },
];

export function getPlanFeatures(plan) {
    const features = [];

    if (plan.maxAutomations > 0) {
        features.push(`Up to ${plan.maxAutomations} active bots (grid, scheduled & algo)`);
    } else {
        features.push('Platform access — upgrade to run live bots');
    }

    if (plan.maxMonitors > 0) {
        features.push(`Up to ${plan.maxMonitors} price & indicator monitors`);
    } else {
        features.push('Manual spot order & wallet monitoring');
    }

    features.push(`${plan.maxBacktests} strategy backtests per month`);

    if (plan.hasFutures) {
        features.push('Spot and futures market support');
        features.push('Order templates, webhooks & unified setup');
    } else {
        features.push('Spot market dashboard access');
        features.push('Futures trading requires a paid plan');
    }

    if (plan.price === 0) {
        features.push('No credit card required');
    } else if (plan.price >= 50) {
        features.push('Priority email support');
    } else {
        features.push('Standard email support');
    }

    return features;
}